import localAxios from '../../localAxios';
import { purgeWorkspaceQuizzesURL } from '../workspacesURLs';

interface PurgeWorkspaceFoldersParams {
  workspaceId: string;
  workspaceQuizIds: string[];
}

export async function purgeWorkspaceQuizzes({
  workspaceId,
  workspaceQuizIds,
}: PurgeWorkspaceFoldersParams) {
  const url = purgeWorkspaceQuizzesURL(workspaceId);
  return localAxios.delete(url.href, {
    data: { workspace_quiz_ids: workspaceQuizIds },
  });
}
